export default __webpack_public_path__ + "static/media/PFSquareSansProItalic_35484.a35f3504.ttf";